import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentsIcon from '@mui/icons-material/Payments';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config";
import { uploads } from "../config";

const ChangePassword = () => {
    const [form, setForm] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [preview, setPreview] = useState("");
    const [data, setData] = useState([]);
    //const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let tempErrors = {};

        if (!form.oldPassword) {
            tempErrors.oldPassword = "Old password is required";
        }

        if (!form.newPassword) {
            tempErrors.newPassword = "New password is required";
        } else if (form.newPassword.length < 8) {
            tempErrors.newPassword = "Password must be at least 8 characters";
        } else if (form.newPassword === form.oldPassword) {
            tempErrors.newPassword = "New password cannot be same as old password";
        }

        if (!form.confirmPassword) {
            tempErrors.confirmPassword = "Confirm password is required";
        } else if (form.confirmPassword !== form.newPassword) {
            tempErrors.confirmPassword = "Passwords do not match";
        }

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        try {
            const response = await fetch(
                `${API_URL}/api-change-password.php`,
                {
                    method: "POST",
                    credentials: "include", // ✅ important for session
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        old_password: form.oldPassword,
                        new_password: form.newPassword,
                    }),
                }
            );

            const result = await response.json(); // ✅ no manual JSON.parse

            console.log("API Response:", result);

            if (!response.ok) {
                alert(result.message || "Request failed");
                return;
            }

            // Backend returns only "message", so check text
            if (result.status === "success") {
                //alert(result.message);
                setMessage(result.message);
                setForm({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
                setErrors({});
                setStatus("success");
            } else {
                //alert(result.message);
                setMessage(result.message);
                setStatus("error");
            }

        } catch (error) {
            console.error("ERROR:", error);
            alert("Something went wrong while calling API");
        }
    };

    // ✅ GET USER PERSONAL DETAILS
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);
                // setFormData(user); // ✅ IMPORTANT: sync editable state

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Change Password</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='bd-left-panel sticky-position'>
                            <div className='db-leftmenu-panel'>
                                <Link to="/dashboard" className='dbtab-menu'><SettingsIcon /> Dashboard</Link>
                                <Link to="/personal-details" className='dbtab-menu'><SettingsIcon /> Personal Details</Link>
                                <Link to="/business-details" className='dbtab-menu'><SettingsIcon /> Business Details</Link>
                                <Link to="/contact-details" className='dbtab-menu'><SettingsIcon /> Contact Details</Link>
                                <Link to="/photo-gallery" className='dbtab-menu'><SettingsIcon /> Photo Gallery</Link>
                                <Link to="/change-password" className='dbtab-menu dbm-active'><SettingsIcon /> Change Password</Link>
                                <Link to="/payment" className='dbtab-menu' style={{ color: "#fff", background: "#237cdb" }}><PaymentsIcon /> Make Payment</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        <div className='bd-right-panel fade-in'>
                            <div className='comp-details'>
                                <div className='logo-box'>
                                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                                        onError={(e) => {
                                            e.target.onerror = null; // prevent infinite loop
                                            e.target.src = "/images/default-profile-pic.jpg";
                                        }} />
                                </div>
                                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                                <div className='location-box'>
                                    <FmdGoodOutlinedIcon />
                                    {data?.business_address ? `${data.business_address}, ` : ""}
                                    {data?.business_city ? `${data.business_city}, ` : ""}
                                    {data?.business_district ? `${data.business_district}, ` : ""}
                                    {data?.business_state ? `${data.business_state} - ` : ""}
                                    {data?.business_zipcode || ""}
                                </div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='db-form-panel'>
                                <div className='heading'>
                                    <h2>Change Password:</h2>
                                    <div className='clr'></div>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className='db-form-edit-details'>


                                        {message && (<div style={{ color: status === "success" ? "#04af04" : "#f71717", margin: "0 0 10px 0", fontSize: "16px", fontWeight: "500" }}>{message}</div>)}


                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='db-form-row'>
                                                    <TextField
                                                        className="db-textbox"
                                                        label="Old Password*"
                                                        name="oldPassword"
                                                        type="password"
                                                        value={form.oldPassword}
                                                        onChange={handleChange}
                                                        error={!!errors.oldPassword}
                                                        helperText={errors.oldPassword}
                                                    />
                                                </div>
                                            </div>
                                            <div className='clr'></div>
                                            <div className='col-md-4'>
                                                <div className='db-form-row'>
                                                    <TextField
                                                        className="db-textbox"
                                                        label="New Password*"
                                                        name="newPassword"
                                                        type="password"
                                                        value={form.newPassword}
                                                        onChange={handleChange}
                                                        error={!!errors.newPassword}
                                                        helperText={errors.newPassword}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='db-form-row'>
                                                    <TextField
                                                        className="db-textbox"
                                                        label="Confirm Password*"
                                                        name="confirmPassword"
                                                        type="password"
                                                        value={form.confirmPassword}
                                                        onChange={handleChange}
                                                        error={!!errors.confirmPassword}
                                                        helperText={errors.confirmPassword}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='db-form-row'>
                                                    <div style={{ textAlign: "left" }}>
                                                        <button className="update-btn">
                                                            Change Password
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangePassword
